const defaultMenuKeys = {
    'item-icon-color': 'rgba(0,0,0,1)',
    'container-vertical-padding': '0px',
    'container-horizontal-padding': '0px',
    'item-vertical-spacing': '0px',
    'item-horizontal-spacing': '0px',
    'sub-items-vertical-spacing-before': '0px',
    'sub-items-vertical-spacing-between': '0px',
    'sub-item-vertical-padding': '0px',
    'sub-item-horizontal-padding': '0px',
    'columns-number': '2',
    anchor: 'menuStretched',
    align: 'start',
    'item-align': 'inherit',
    'sub-item-align': 'inherit',
    'horizontal-margin': '0px',
    'space-above': '0px',
    'scroll-button-box-shadow': 'none',
    'scroll-button-icon-rotation': '0',
    'item-text-outline': '1px 0px transparent, -1px 0px transparent, 0px 1px transparent, 0px -1px transparent',
    'item-text-highlight': 'none',
    'item-text-shadow': '0px 0px transparent',
    'item-icon-size': '10px',
    'item-divider': '1px solid rgba(0,0,0,1)',
    'item-text-align': 'center',
    'item-direction': 'ltr',
    'item-vertical-padding': '0px',
    'item-horizontal-padding': '0px',
    'display-mode': 'navbar',
    'spacing-between-label-and-dropdown-icon': '0px',
    'menu-items-main-axis-gap': '0px',
    'menu-items-cross-axis-gap': '0px',
    orientation: 'horizontal',
    overflow: 'wrap',
    'container-direction': 'ltr',
    'container-align': 'start'
}

module.exports = {
    defaultMenuKeys
}
